import { render, staticRenderFns } from "./CommonRiskSchedule.vue?vue&type=template&id=48a1536b&scoped=true"
import script from "./CommonRiskSchedule.vue?vue&type=script&lang=js"
export * from "./CommonRiskSchedule.vue?vue&type=script&lang=js"
import style0 from "./CommonRiskSchedule.vue?vue&type=style&index=0&id=48a1536b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a1536b",
  null
  
)

export default component.exports